import { render, staticRenderFns } from "./CoMorbidities.vue?vue&type=template&id=60d8a6ae"
import script from "./CoMorbidities.vue?vue&type=script&lang=js"
export * from "./CoMorbidities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports